import React from 'react'
import cn, { Argument as ClassName } from 'classnames'

export interface Props extends Omit<React.SVGProps<SVGSVGElement>, 'className'> {
    name?: string
    size?: string | number
    className?: ClassName
}

const convertSizeToStyle = (size?: string | number) => {
    if (!size) return null
    const normalizedSize = typeof size === 'number' || size.match(/^\d+$/) ? `${size}px` : size
    return { width: normalizedSize, height: normalizedSize }
}

const IconSvgContainer = ({
    children,
    className = undefined,
    name = undefined,
    size = undefined,
    style = {},
    width = 24,
    height = 24,
    viewBox = `0 0 ${width} ${height}`,
    fill = 'none',
    xmlns = 'http://www.w3.org/2000/svg',
    ...rest
}: Props): React.ReactElement => (
    <svg
        className={cn('icon', { [`icon--${name}`]: name }, className)}
        width={width}
        height={height}
        viewBox={viewBox}
        fill={fill}
        xmlns={xmlns}
        style={{ ...style, ...convertSizeToStyle(size) }}
        {...rest}
    >
        {children}
    </svg>
)

export default IconSvgContainer
